





import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import SupportCaseSlider from './components/support-case-slider.vue';

@Component({
  components: {
    ...UUIFComponents,
    SupportCaseSlider,
  },
})

export default class MswSupportCases extends SwExtendedVue {
  created() {
    console.warn('Support case slider');
  }
}
